export default "__VITE_ASSET__68b872fb__"